import { Link } from "react-router-dom";
import { Building, MapPin, Phone, Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-foreground text-background py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          <div className="animate-fade-in">
            <div className="flex items-center space-x-2 mb-4">
              <img 
                src="/images/samac-logo.svg .png"
                alt="SAMAC Technology Logo" 
                className="h-8 w-8 object-contain"
                onError={(e) => {
                  // Fallback to Building icon if logo image fails to load
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'none';
                  const fallback = document.createElement('div');
                  fallback.innerHTML = '<svg class="h-6 w-6 text-background" fill="none" stroke="currentColor" viewBox="0 0 24 24"><rect width="16" height="20" x="4" y="2" rx="2" ry="2"/><path d="M9 22v-4h6v4"/><path d="M8 6h.01"/><path d="M16 6h.01"/><path d="M12 6h.01"/><path d="M12 10h.01"/><path d="M12 14h.01"/><path d="M16 10h.01"/><path d="M16 14h.01"/><path d="M8 10h.01"/><path d="M8 14h.01"/></svg>';
                  target.parentNode?.insertBefore(fallback, target);
                }}
              />
              <div>
                <h3 className="font-bold">SAMAC Technology</h3>
                <p className="text-sm text-background/70">& Networking Solutions, Inc.</p>
              </div>
            </div>
            <p className="text-background/70 mb-4">
              Comprehensive IT service provider specializing in technology infrastructure, 
              consulting, and sales for over two decades.
            </p>
          </div>
          
          <div className="animate-fade-in">
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-background/70">
              <li>
                <Link to="/" className="hover:text-background transition-colors hover:underline">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-background transition-colors hover:underline">
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-background transition-colors hover:underline">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-background transition-colors hover:underline">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          
          <div className="animate-fade-in">
            <h4 className="font-semibold mb-4">Contact Info</h4>
            <div className="space-y-2 text-background/70">
              <div className="flex items-center space-x-2">
                <MapPin className="h-4 w-4 flex-shrink-0" />
                <span>Durant, Mississippi</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="h-4 w-4 flex-shrink-0" />
                <span>Professional IT Consultation</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="h-4 w-4 flex-shrink-0" />
                <span>Technology Solutions</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-background/20 mt-8 pt-8 text-center text-background/70">
          <p>&copy; 2024 SAMAC Technology & Networking Solutions, Inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;